import { Vote, Activity, Coins, BookOpen, BarChart3, type LucideIcon } from 'lucide-react';

interface SearchExample {
	/** Short label displayed in the chip */
	label: string;
	/** Full query string inserted into the search input */
	query: string;
}

interface ExampleCategory {
	id: string;
	icon: LucideIcon;
	examples: SearchExample[];
}

export const EXAMPLE_CATEGORIES: ExampleCategory[] = [
	{
		id: 'governance',
		icon: Vote,
		examples: [
			{
				label: 'Active votes on Polkadot',
				query: "What's being voted on right now on Polkadot?"
			},
			{
				label: 'Kusama treasury proposals',
				query: 'Show me recent treasury proposals on Kusama'
			},
			{
				label: 'Active bounties on Polkadot',
				query: 'What bounties are active on Polkadot?'
			},
			{
				label: 'Fellowship referenda',
				query: 'What are the latest Fellowship referenda on Polkadot?'
			},
			{
				label: 'Referendum #1839 details',
				query: 'What is referendum 1839 about on Polkadot?'
			},
			{
				label: 'Top Polkadot delegates',
				query: 'Who are the top delegates on Polkadot OpenGov?'
			}
		]
	},
	{
		id: 'on-chain',
		icon: Activity,
		examples: [
			{
				label: 'Account activity on Polkadot',
				query: 'What has account "13EyMuuDHwtq5RD6w3psCJ9WvJFZzDDion6Fd2FVAqxz1g7K" been doing on Polkadot?'
			},
			{
				label: 'Kusama validators',
				query: 'Who are the top validators on Kusama?'
			},
			{
				label: 'Recent Polkadot transfers',
				query: 'What are the latest transfers on Polkadot?'
			},
			{
				label: "Saxemberg's address",
				query: "What's Saxemberg's address on Polkadot?"
			},
			{
				label: 'ChaosDAO vote check',
				query: 'Did ChaosDAO vote on referendum 1839 on Polkadot?'
			},
			{
				label: 'Token holdings',
				query: 'What tokens does "13EyMuuDHwtq5RD6w3psCJ9WvJFZzDDion6Fd2FVAqxz1g7K" hold on Polkadot?'
			}
		]
	},
	{
		id: 'market',
		icon: Coins,
		examples: [
			{
				label: 'Current DOT price',
				query: "What's the current DOT price?"
			},
			{
				label: 'KSM market cap',
				query: "What's KSM's market cap and trading volume?"
			},
			{
				label: 'DOT price history (30 days)',
				query: 'Show the DOT price chart for the last 30 days'
			},
			{
				label: 'DOT vs KSM price comparison',
				query: 'Compare the current price and market cap of DOT and KSM'
			},
			{
				label: 'DOT all-time high',
				query: 'What is the all-time high price of DOT and when did it happen?'
			},
			{
				label: 'KSM circulating supply',
				query: 'How many KSM tokens are in circulation?'
			}
		]
	},
	{
		id: 'analytics',
		icon: BarChart3,
		examples: [
			{
				label: 'Top DOT holders',
				query: 'Who are the top DOT holders on Polkadot?'
			},
			{
				label: 'DOT transferred this week',
				query: 'How much DOT was transferred on Polkadot this week?'
			},
			{
				label: 'USDT transfers on Asset Hub',
				query: 'Show the latest USDT transfers on Polkadot Asset Hub'
			},
			{
				label: 'Kusama transfer count trend',
				query: 'How many transfers happened on Kusama each day over the past week?'
			},
			{
				label: 'Largest DOT transfers today',
				query: 'What are the largest DOT transfers on Polkadot in the last 24 hours?'
			},
			{
				label: 'DOT holder count',
				query: 'How many accounts hold more than 1000 DOT?'
			}
		]
	},
	{
		id: 'knowledge',
		icon: BookOpen,
		examples: [
			{
				label: 'What is Asset Hub?',
				query: 'What is Asset Hub and how does it work?'
			},
			{
				label: 'How does OpenGov work?',
				query: 'How does OpenGov governance work on Polkadot?'
			},
			{
				label: 'Polkadot vs Kusama',
				query: 'What is the difference between Polkadot and Kusama?'
			},
			{
				label: 'How does XCM work?',
				query: 'How does cross-chain messaging (XCM) work in Polkadot?'
			},
			{
				label: 'Staking on Polkadot',
				query: 'How does nominated proof-of-stake work on Polkadot?'
			},
			{
				label: 'What is Agile Coretime?',
				query: 'What is Agile Coretime and how does it replace parachain auctions?'
			}
		]
	}
];
